import React, { useState } from 'react';
import { Box, Button, CircularProgress, Grid, Link, Paper, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Helmet } from 'react-helmet';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import globalUseStyles from '../../config/themes/globalStyles';
import Google from '../../images/google.jpg';
import Microsoft from '../../images/microsoft.png';
import loginBg from '../../images/loginBg.jpg';
import image1 from '../../images/image1.svg';
import image3 from '../../images/image3.png';
import image2 from '../../images/HCM-software.png';
import evonsysLogo from '../../images/logo.png';
import minori_logo from '../../images/minori-logo.svg';
import Signin from './loginPage';
import { ForgotPassword } from './ForgotPassword';
import oAuthAuthentication from '../../config/sso/microsoftsso';
import { BrandingLogo } from '../utils/GetCompanyLogo';

const ColorButton = withStyles({
  root: {
    color: '#ffffff',
    backgroundColor: '#3866fa',
    borderRadius: '8px',
    padding: '10px 20px',
    fontWeight: 'bold',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#2c54c9',
    },
  },
})((props) => <Button {...props} />);

const getCompanyLogo = (logo) => {
  const logos = {
    evonsys: evonsysLogo,
    minori: minori_logo,
  };
  return logos[logo] ? (
    <img src={logos[logo]} alt="logo" style={{ maxWidth: '150px' }} />
  ) : null;
};

function NewLoginPage({ SSOLogin }) {
  const theme = useTheme();
  const mobileMatchMediaQuery = useMediaQuery(theme.breakpoints.down('md'));
  const globalStyles = globalUseStyles();
  const dispatch = useDispatch();
  const loginLoader = useSelector((state) => state.loggedIn.loginLoader);
  const authType = useSelector((state) => state.loggedIn.authType);
  const [isForgotPasswordEnabled, setForgotPasswordEnable] = useState(false);

  const microsoftLogin = () => oAuthAuthentication(dispatch, 'microsoft').onOAuthBtnClick();
  const googleLogin = () => oAuthAuthentication(dispatch, 'google').onOAuthBtnClick();

  const renderLoginButtons = () => (
    <Grid container spacing={2} justifyContent="center">
      <Grid item>
        <ColorButton
          size="large"
          onClick={microsoftLogin}
          startIcon={<img src={Microsoft} alt="Microsoft" style={{ width: '20px' }} />}
          disabled={loginLoader}>
          Microsoft
          {loginLoader && authType === 'microsoft' && (
            <CircularProgress size={20} sx={{ ml: 1 }} />
          )}
        </ColorButton>
      </Grid>
      <Grid item>
        <ColorButton
          size="large"
          onClick={googleLogin}
          startIcon={<img src={Google} alt="Google" style={{ width: '20px' }} />}
          disabled={loginLoader || true}>
          Google
          {loginLoader && authType === 'google' && (
            <CircularProgress size={20} sx={{ ml: 1 }} />
          )}
        </ColorButton>
      </Grid>
    </Grid>
  );

  const renderImages = () => (
    <Grid container justifyContent="space-evenly" className={globalStyles.flexRowAlignCenter}>
      {[image1, image3, image2].map((src, index) => (
        <img
          key={index}
          src={src}
          alt={`illustration-${index}`}
          style={{ maxWidth: mobileMatchMediaQuery ? '65%' : '25%' }}
        />
      ))}
    </Grid>
  );

  return (
    <div
      className="loginPage"
      style={{
        backgroundImage: mobileMatchMediaQuery
          ? 'none'
          : `linear-gradient(rgba(255,255,255,.7), rgba(255,255,255,.9)), url(${loginBg})`,
        backgroundSize: 'cover',
        minHeight: '90vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Helmet>
        <title>Login</title>
      </Helmet>

      <Paper
        style={{
          backgroundColor: '#ffffff',
          margin: mobileMatchMediaQuery ? '0px' : '100px',
          padding: '20px',
          borderRadius: '16px',
          boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.1)',
        }}>
        <Grid container>
          <Grid
            item
            lg={8}
            xs={12}
            sx={{
              backgroundColor: mobileMatchMediaQuery ? '#ffffff' : '#3866fa',
              color: mobileMatchMediaQuery ? '#000' : '#fff',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px',
              borderRadius: '8px',
            }}>
            {!mobileMatchMediaQuery && renderImages()}

            {!mobileMatchMediaQuery && (
              <Box mt={3} textAlign="center">
                <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
                  New here?
                </Typography>
                <Typography variant="body2">
                  Please reach out to HR/Resource Manager to proceed further.
                </Typography>
                {!window.LOGOURL && (
                  <Link
                    href="https://peoplehcm.com/"
                    target="_blank"
                    sx={{
                      textDecoration: 'none',
                      color: '#ffffff',
                      display: 'block',
                      mt: 2,
                    }}>
                    <Button variant="outlined" color="inherit">
                      Explore PeopleHCM
                    </Button>
                  </Link>
                )}
              </Box>
            )}
          </Grid>

          <Grid
            item
            lg={4}
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: mobileMatchMediaQuery ? '150px' : '350px',
            }}>
            <Grid container alignItems="center" justifyContent="center">
              <BrandingLogo />
            </Grid>

            {SSOLogin ? (
              <Box mt={3}>{renderLoginButtons()}</Box>
            ) : (
              <Box>
                {isForgotPasswordEnabled ? (
                  <ForgotPassword setForgotPasswordEnable={setForgotPasswordEnable} />
                ) : (
                  <Signin
                    mobileMatchMediaQuery={mobileMatchMediaQuery}
                    SSOLogin={SSOLogin}
                    setForgotPasswordEnable={setForgotPasswordEnable}
                  />
                )}
              </Box>
            )}
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}

export default NewLoginPage;
